// extracted by mini-css-extract-plugin
export default {"box":"DonutColors_box__0jcqm","body":"DonutColors_body__kao3F","empty":"DonutColors_empty__3bYe8"};